import React from 'react';

export const responsibilityMessages = {
  value: 'Responsibility',
  list: [
    {
      value: (
        <>
          Glints reserves the right to monitor the Site and its contents at any
          time, but is not obliged to do so. Glints takes no responsibility
          whatsoever for any material on the Site that is not posted by Glints
          or is otherwise posted by Glints on behalf of a user. All users
          acknowledge and agree that they are fully responsible for the form,
          content and accuracy of any resume, information, data, advertisement,
          web page and/or material submitted by them to Glints or that is
          otherwise posted by them on or through the Site. Glints does not
          warrant that any resume, information, data, advertisement or web page
          will be viewed by any specific number of users or that it will be
          viewed by any specific user or result in successful recruitment of
          personnel. Glints shall not in any way be considered an agent of
          either Advertiser or Job Seeker with respect to any use of the Site.
          Glints shall not be responsible in any way for any decision, for
          whatever reason, made by any party seeking or posting jobs on the
          Site, or of any party responding to or posting advertisements on the
          Site. Whilst Glints has endeavored to provide a quality service to
          advertisers and job seekers, it does not warrant that the site will
          operate error-free or that the site and its server are free of viruses
          or other harmful mechanisms, that any defects will be corrected, or
          that the operation of the site will be uninterrupted, timely or
          secure. If use of the site or its contents result in the need for
          servicing or replacing equipment or data, by any user, Glints shall
          not be responsible for those costs and any loss or damage of whatever
          nature. The site and its contents are provided on an “as is” basis
          without any warranties of any kind. To the fullest extent permitted by
          law, Glints disclaims all warranties, including without prejudice to
          the foregoing, any warranties in respect of merchantability,
          availability of featured products or services, non-infringement of
          third party rights, fitness for particular purpose, or about the
          accuracy, reliability, completeness, timeliness or other qualities of
          the site and the contents, services, software, text, graphics and
          links contained therein. Users should independently assess and verify
          the accuracy, completeness and reliability of the information on the
          site and to seek professional advice where necessary.
        </>
      ),
    },
  ],
};
